import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import SurveyTable from './SurveyTable';

function Survey() {
    const [searchPanelOpen, setSearchPanelOpen] = useState(false);

    return (
        <div className="container-fluid">
            <div className="pagetitle d-flex justify-content-between align-items-center">
                <h1>
                    <i className="bi bi-clipboard-data"></i> Survey Templates
                </h1>
                <Link to="/surveys/new" className="btn btn-sm btn-outline-primary">
                    <i className="bi bi-plus"></i> Create New Survey
                </Link>
            </div>
            <Card className="card-padding shadow-sm border-0">
                <Card.Body className="p-3">
                    <SurveyTable
                        searchPanelOpen={searchPanelOpen}
                        onSearchPanelToggle={() => setSearchPanelOpen((open) => !open)}
                    />
                </Card.Body>
            </Card>
        </div>
    );
}

export default Survey;
